/* eslint-disable */
import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';

const LeftMenuPanelPopup = () => {

    // loggedin user data
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    const token = localStorage.getItem('token') || '';

    const [activeMenu, setActiveMenu] = useState(null);
    const submenuRefs = useRef({});

    const toggleSubmenu = (menu) => {
        setActiveMenu((prevMenu) => {
            if (prevMenu === menu) {
                animateHeight(menu, false);
                return null;
            } else {
                if (prevMenu) animateHeight(prevMenu, false);
                animateHeight(menu, true);
                return menu;
            }
        });
    };

    const animateHeight = (menu, expand) => {
        const submenu = submenuRefs.current[menu];
        if (submenu) {
            submenu.style.height = expand ? `${submenu.scrollHeight}px` : '0px';
            if (expand) {
                submenu.addEventListener(
                    'transitionend',
                    () => (submenu.style.height = 'auto'),
                    { once: true }
                );
            } else {
                submenu.style.height = `${submenu.scrollHeight}px`;
                requestAnimationFrame(() => (submenu.style.height = '0px'));
            }
        }
    };

    const menuItemStyle = {
        textDecoration: 'none',
        padding: '12px 15px',
        borderRadius: '8px',
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        width: '100%',
        fontSize: '14px',
        fontWeight: '500'
    };

    const submenuItemStyle = {
        textDecoration: 'none',
        padding: '10px 15px 10px 45px',
        borderRadius: '6px',
        transition: 'all 0.2s ease',
        display: 'block',
        width: '100%',
        fontSize: '13px'
    };

    const iconStyle = {
        fontSize: '20px',
        minWidth: '20px'
    };

    return (
        <div
            className="offcanvas offcanvas-start bg-white border-0"
            data-bs-scroll="true"
            data-bs-backdrop="static"
            id="offcanvasMainNav"
            aria-labelledby="offcanvasMainNavLabel"
            style={{ width: '300px' }}
        >
            <div className="offcanvas-header flex-column align-items-start body-bg p-4">
                <button
                    type="button"
                    className="btn-close p-0 bg-white rounded-circle shadow-none m-0"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                >
                    <span className="d-block material-symbols-outlined icon-lg">arrow_back</span>
                </button>
                <div className="user d-flex align-items-center gap-3 mt-4">
                    <div className="avatar rounded-circle overflow-hidden" style={{ width: '48px', height: '48px' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/img/user.png`}
                            alt={userInfo.name}
                            className="w-100 h-100 object-fit-cover object-center"
                        />
                    </div>
                    <div className="name">
                        <p className="fs-md fw-semibold mb-0">{userInfo.name}</p>
                        <p className="fs-xs lh-1 text-gray">{userInfo.role?.name ?? ''}</p>
                    </div>
                </div>
            </div>
            
            <div className="offcanvas-body px-3 py-4">
                <nav className="nav flex-column gap-1">
                    
                    {/* Dashboard */}
                    <div className="nav-item">
                        <Link 
                            to="/dmdashboard" 
                            className="text-dark nav-link"
                            style={menuItemStyle}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#f8f9fa';
                                e.target.style.transform = 'translateX(2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.transform = 'translateX(0)';
                            }}
                        >
                            <span className="material-symbols-outlined" style={iconStyle}>dashboard</span>
                            Dashboard
                        </Link>                    
                    </div>

                    {/* Administration */}
                    <div className="nav-item">
                        <Link
                            to="#"
                            className="text-dark nav-link"
                            style={menuItemStyle}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#f8f9fa';
                                e.target.style.transform = 'translateX(2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.transform = 'translateX(0)';
                            }}
                            onClick={() => toggleSubmenu('administration')}
                        >
                            <span className="material-symbols-outlined" style={iconStyle}>settings</span>
                            Administration
                            <span 
                                className="material-symbols-outlined ms-auto" 
                                style={{ 
                                    fontSize: '18px',
                                    transform: activeMenu === 'administration' ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease'
                                }}
                            >
                                expand_more
                            </span>
                        </Link>
                        <ul
                            ref={(el) => (submenuRefs.current['administration'] = el)}
                            className="nav flex-column gap-1 mt-1"
                            style={{
                                height: activeMenu === 'administration' ? 'auto' : '0px',
                                overflow: 'hidden',
                                transition: 'height 0.3s ease',
                            }}
                        >
                            <li>
                                <Link 
                                    to="#" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Pricing templates
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/treatmentTemplate" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Treatment Templates
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/laboratoryTemplates" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Laboratory Templates
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/catalog" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Product/Service Catalog
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/supplierPriceLists" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Supplier Price Lists
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/costumerPriceLists" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Costumer Price Lists
                                </Link>
                            </li>
                        </ul>
                    </div>
                    
                    {/* Clinical Management */}
                    <div className="nav-item">
                        <Link
                            to="#"
                            className="text-dark nav-link"
                            style={menuItemStyle}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#f8f9fa';
                                e.target.style.transform = 'translateX(2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.transform = 'translateX(0)';
                            }}
                            onClick={() => toggleSubmenu('clinicalManagement')}
                        >
                            <span className="material-symbols-outlined" style={iconStyle}>medical_services</span>
                            Clinical Management
                            <span 
                                className="material-symbols-outlined ms-auto" 
                                style={{ 
                                    fontSize: '18px',
                                    transform: activeMenu === 'clinicalManagement' ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease'
                                }}
                            >
                                expand_more
                            </span>
                        </Link>
                        <ul
                            ref={(el) => (submenuRefs.current['clinicalManagement'] = el)}
                            className="nav flex-column gap-1 mt-1"
                            style={{
                                height: activeMenu === 'clinicalManagement' ? 'auto' : '0px',
                                overflow: 'hidden',
                                transition: 'height 0.3s ease',
                            }}
                        >
                            <li>
                                <Link 
                                    to="/doctors/list" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Doctors
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/patients/list" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Patients
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/treatments" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Treatments
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/healthCenter" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Health Centers
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/medicines" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Medicines
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/inventory" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Inventory
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/prescriptions" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Prescriptions
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/vaccinations" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Vaccination
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/timeline" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Appointments/Timeline
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/billable-activities" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Billable Activities
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Patient Management */}
                    <div className="nav-item">
                        <Link
                            to="#"
                            className="text-dark nav-link"
                            style={menuItemStyle}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#f8f9fa';
                                e.target.style.transform = 'translateX(2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.transform = 'translateX(0)';
                            }}
                            onClick={() => toggleSubmenu('patientManagement')}
                        >
                            <span className="material-symbols-outlined" style={iconStyle}>person</span>
                            Patient Management
                            <span 
                                className="material-symbols-outlined ms-auto" 
                                style={{ 
                                    fontSize: '18px',
                                    transform: activeMenu === 'patientManagement' ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease'
                                }}
                            >
                                expand_more
                            </span>
                        </Link>
                        <ul
                            ref={(el) => (submenuRefs.current['patientManagement'] = el)}
                            className="nav flex-column gap-1 mt-1"
                            style={{
                                height: activeMenu === 'patientManagement' ? 'auto' : '0px',
                                overflow: 'hidden',
                                transition: 'height 0.3s ease',
                            }}
                        >
                            <li>
                                <Link 
                                    to="/my-appointments" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    My Appointments
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/my-prescriptions" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    My Prescriptions
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/my-conditions" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    My Conditions
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/my-medications" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    My Medications
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/my-allergies" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    My Allergies
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/my-immunizations" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    My Immunizations
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/my-results" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    My Results
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/my-vitals" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    My Vitals
                                </Link>
                            </li>                            
                            <li>
                                <Link 
                                    to="/my-electronic-prescriptions" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    My Electronic Prescriptions
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/my-orders" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    My Orders
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/my-consents" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    My Consent
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/my-profile-settings" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Profile Settings
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Tools */}
                    <div className="nav-item">
                        <Link
                            to="#"
                            className="text-dark nav-link"
                            style={menuItemStyle}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#f8f9fa';
                                e.target.style.transform = 'translateX(2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.transform = 'translateX(0)';
                            }}
                            onClick={() => toggleSubmenu('tools')}
                        >
                            <span className="material-symbols-outlined" style={iconStyle}>build</span>
                            Tools
                            <span 
                                className="material-symbols-outlined ms-auto" 
                                style={{ 
                                    fontSize: '18px',
                                    transform: activeMenu === 'tools' ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease'
                                }}
                            >
                                expand_more
                            </span>
                        </Link>
                        <ul
                            ref={(el) => (submenuRefs.current['tools'] = el)}
                            className="nav flex-column gap-1 mt-1"
                            style={{
                                height: activeMenu === 'tools' ? 'auto' : '0px',
                                overflow: 'hidden',
                                transition: 'height 0.3s ease',
                            }}
                        >
                            <li>
                                <Link 
                                    to="/diagnostic-assistant" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Diagnostic Assistant
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/smarttranslator" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Smart Translator
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/visualizer" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Vizualizer
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/electronic-prescription" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Electronic Prescription
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/symptom-assistant" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Symptom Assistant
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/company-process/list" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Company Process
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/digimevo" 
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    Assign Videos to patient
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/dashboardGlobal"
                                    className="text-secondary nav-link"
                                    style={submenuItemStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.color = '#495057';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#6c757d';
                                    }}
                                >
                                    STONEWEG
                                </Link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    );
};

export default LeftMenuPanelPopup;